import { createSlice } from '@reduxjs/toolkit';
import { optionAction } from '../actions';
import { optionReducer as extraReducers } from '../reducers';
import { IOptionState } from '../../interfaces';

const initialState: IOptionState = {
  status: 'inactive',
  options: [],
  error: '',
};

export const optionSlice = createSlice({
  name: 'option',
  initialState,
  // Non-async reducers
  reducers: {
    resetOption: () => {
      return initialState;
    },
  },
  // Async reducers
  extraReducers,
});

// Action creators are generated for each case reducer function
export const optionSliceActions = { ...optionSlice.actions, ...optionAction };

export default optionSlice.reducer;
